import React from 'react';
import PrivateRoute from '../privateRoute/PrivateRoute.jsx';
import Login from '../pages/login/Login.jsx';
import {Switch, Route, Redirect} from 'react-router-dom'
import SessionInfo from '../pages/info/SessionInfo';
import Home from '../pages/home/Home';
import PublicOnlyRoute from '../privateRoute/PublicOnlyRoute';
import Owners from '../pages/owners/Owners';
import Providers from '../pages/provider/Providers';
import ProviderThresholds from '../pages/provider-thresholds/ProviderThresholds';
import PenHealth from '../pages/pen-health/PenHealth';
import PenHealthDetail from '../pages/pen-health/PenHealthDetail';
import Consumers from '../pages/consumers/Consumers';
import DataStreams from '../pages/data-streams/DataStreams';
import Devices from '../pages/devices/Devices';
import ConsumerTypes from '../pages/consumer-types/ConsumerTypes';
import ChangePassword from '../pages/login/ChangePassword';

const Routes = ({}) => {
  return (
    <div>
      <Switch>
        <Route path='/info' render={props => <SessionInfo {...props} />} />
        <Route path='/' exact render={_ => <Redirect to='/home'/>} />
        <PublicOnlyRoute path='/login' render={props => <Login {...props} />} />
        <Route path='/changepassword' render={props => <ChangePassword {...props} />} />
        <PrivateRoute path='/home' render={props => <Home {...props} />} />
        <PrivateRoute path='/owners' render={props => <Owners {...props} />} />
        <PrivateRoute path='/providers' render={props => <Providers {...props} />} />
        <PrivateRoute path='/provider-thresholds' render={props => <ProviderThresholds {...props} />} />
        <PrivateRoute path='/pen-health/:businessId' render={props => <PenHealthDetail {...props} />} />
        <PrivateRoute path='/pen-health' render={props => <PenHealth {...props} />} />
        <PrivateRoute path='/consumers' render={props => <Consumers {...props} />} />
        <PrivateRoute path='/data-streams' render={props => <DataStreams {...props} />} />
        <PrivateRoute path='/consumerTypes' render={props => <ConsumerTypes {...props} />} />
        <PrivateRoute path='/devices' render={props => <Devices {...props} />} />

      </Switch>
    </div>
  )

}

export default Routes;
